module.exports = __webpack_public_path__ + "img/window-edit.d823020f.svg";